import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../store/actions/notificationAction';

import pickupOrderRemote from '../../../api/pickupOrderRemote';
import OrderWhsDetails from '../../../models/OrderWhsDetails';
import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import WhsOrderAwbReport from './WhsOrderAwbReport';
import GhaWhPoAwbException from '../../../models/GhaWhPoAwbException';
import { OrderLockStatusType } from '../../../models/OrderLockStatusType.enum';
import GhaPickupStatusAwb from '../../../models/GhaPickupStatusAwb';
import { PO_AWB_SCHEMA } from '../../../utils/pickupOrder';
import GhaPickupStatus from '../../../models/GhaPickupStatus';
import { version } from 'process';

interface WhsOrderAwbReportContainerProps {
  type: string;
  history: { push: Function };
  match: { isExact: boolean; params: { awbCode: string; awbNumber: string; awbVersion: string; orderNumber: string }; path: string; url: string; };
  location: any;
  receiveError: Function;
  orderLockedNumber: string;
  requestOrderUnlocked: Function;
};
  
interface WhsOrderAwbReportContainerState {
  orderAwb: GhaPickupStatusAwb;
  selectedAwb: string;
  exceptions: GhaWhPoAwbException;
  onlyRead: boolean;
  order: { 
    lock_status: string,
    gha_wh_user_name: string
  },
  selectAll: boolean;
};

class WhsOrderAwbReportContainer extends Component<WhsOrderAwbReportContainerProps, WhsOrderAwbReportContainerState> {

  state = {
    orderAwb: PO_AWB_SCHEMA,
    selectedAwb: '',
    exceptions: {
      contents_damaged: false,
      exception: [
        {
          id: -1,
          name: '',
          selected: false
        }
      ],
      note: '',
      packaging: [
        {
          id: -1,
          name: '',
          selected: false
        }
      ],
      not_delivered_pieces: 0,
      not_delivered_weight: 0,
      parts: [],
      attachments: new Array<string>(),
    },
    onlyRead: false,
    order: {
      lock_status: '',
      gha_wh_user_name: '',
      driver_signature_key: ''
    },
    selectAll: false
  }
  
  componentDidMount() {

    const orderNumber: string = this.props.match.params.orderNumber;
    const awbCode: string = this.props.match.params.awbCode;
    const awbNumber: string = this.props.match.params.awbNumber;
    const awbVersion: number = Number(this.props.match.params.awbVersion);

    if(this.props.location.state) {
      const onlyRead = this.props.location.state.onlyRead;
      this.setState({ onlyRead })
     
    }

    pickupOrderRemote.getGhaPoAwbWhExceptions(orderNumber, awbCode, awbNumber).then((resp: ApiResponse<GhaWhPoAwbException>) => {

      const exceptions: GhaWhPoAwbException | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (exceptions) {
        this.setState({ exceptions, selectedAwb: awbCode + '-' + awbNumber });

        pickupOrderRemote.getPickupOrderWhs(orderNumber).then((resp: ApiResponse<OrderWhsDetails>) => {

          const order: OrderWhsDetails | undefined = resp.result;
          const error: ResponseError | undefined = resp.error;
    
          if (order) {
            
            this.setState({ order });
    
            if(order.lock_status === OrderLockStatusType.UNLOCKED && !this.state.order.driver_signature_key) {
              this.doLockPickupOrder();
            }
          }
    
          if (error) {
            this.props.receiveError(error);
          };
        });
      }

      if (error) {
        this.props.receiveError(error);
      };
    });

    pickupOrderRemote.getGhaPoAwb(orderNumber, awbCode, awbNumber, awbVersion).then((resp: ApiResponse<GhaPickupStatus>) => {

      const order: GhaPickupStatus | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (order) {
        this.setState({ orderAwb: order.po_awb });
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  componentWillUnmount() {

    if(!this.state.order.driver_signature_key) {
      this.doLockPickupOrder();
    }
  }

  doLockPickupOrder = (): void => {

    const locked: boolean = this.state.order.lock_status === OrderLockStatusType.UNLOCKED;
    const number: string = this.props.match.params.orderNumber;

    pickupOrderRemote.doGhaWhPoLock(number, locked).then((resp: ApiResponse<{ lock_status: string; gha_wh_user_name: string; }>) => {

      const updateValues: { lock_status: string; gha_wh_user_name: string; } | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (updateValues) {
        const order = { ...this.state.order };

        order.lock_status = updateValues.lock_status;
        order.gha_wh_user_name = updateValues.gha_wh_user_name;

        this.setState({ order });
      }
  
      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  handleChange = (type: string, excOrPackData?: { index: number, value: boolean }, event?: any, partId?: number): void => {

    const currExc: GhaWhPoAwbException = { ...this.state.exceptions };

    switch (type) {

      case 'contents_damaged':

        if (event) {
          const value: boolean | null = event.target.value === 'true' ? true : (event.target.value === 'false' ? false : null);
          currExc.contents_damaged = value;
        }

        break;
      case 'exception':
      case 'packaging':

        if (excOrPackData) {
          const ind: number = excOrPackData.index;
          currExc[type][ind].selected = !excOrPackData.value;
        }

        break;
      case 'note':
        if (event) {
          currExc.note = event.target.value;          
        }
        break;
      case 'pcs':
        if (event && partId !== undefined) {
          currExc.parts[partId].not_delivered_pieces = Number(event.target.value);
        }         
        break;
      case 'weight':
        if (event && partId !== undefined) {
          currExc.parts[partId].not_delivered_weight = Number(event.target.value);
        }         
        break;
      default: break;
    }

    this.setState({ exceptions: currExc });
  }

  showOnPodChange = (type: string, index: number): void => {
    const orderAwb = { ...this.state.orderAwb };
    orderAwb.show_on_pod.data[index].value = !orderAwb.show_on_pod.data[index].value;
    this.setState({ orderAwb });
  }

  selectAllChange = (): void => {
    const selectAllValue = this.state.selectAll;
    const orderAwb = { ...this.state.orderAwb };
    orderAwb.show_on_pod.data.forEach((el: any) => {
      el.value = !el.value;
    });
    this.setState({ selectAll: !selectAllValue, orderAwb });
  }

  saveExit = (type: string): void => {

    const orderNumber: string = this.props.match.params.orderNumber;
    const awbCode: string = this.props.match.params.awbCode;
    const awbNumber: string = this.props.match.params.awbNumber;

    if (type === 'save') {

      pickupOrderRemote.updateGhaPoAwbWhExceptions(orderNumber, awbCode, awbNumber, this.state.exceptions).then((resp: ApiResponse<boolean>) => {

        const updated: boolean | undefined = resp.success;
        const error: ResponseError | undefined = resp.error;

        if (updated) {
          pickupOrderRemote.savePodData(orderNumber, awbCode, awbNumber, this.state.orderAwb.show_on_pod).then((resp: ApiResponse<boolean>) => {
            const result: boolean | undefined = resp.success;
            const error: ResponseError | undefined = resp.error;
      
            if (result) {
             
            this.props.history.push({
              pathname: `/whs/${this.props.type}/${orderNumber}`,
              state: {
                selectedAwb: this.state.selectedAwb,
                version: this.props.match.params.awbVersion
              }
            });
            }
      
            if (error) {
              this.props.receiveError(error);
            };
          })
        }
  
        if (error) {
          this.props.receiveError(error);
        };
      });
      
    } else {
      this.props.history.push({
        pathname: `/whs/${this.props.type}/${orderNumber}`,
        state: {
          selectedAwb: this.state.selectedAwb
        }
      });
    }
  }

  returnToDriverAwb = () => {
    const orderNumber: string = this.props.match.params.orderNumber;
    const awbCode: string = this.props.match.params.awbCode;
    const awbNumber: string = this.props.match.params.awbNumber;
    const awbVersion: string = this.props.match.params.awbVersion;
    pickupOrderRemote.updateGhaPoAwbWhExceptions(orderNumber, awbCode, awbNumber, this.state.exceptions).then((resp: ApiResponse<boolean>) => {

      const updated: boolean | undefined = resp.success;
      const error: ResponseError | undefined = resp.error;

      if (updated) {
        pickupOrderRemote.savePodData(orderNumber, awbCode, awbNumber, this.state.orderAwb.show_on_pod).then((resp: ApiResponse<boolean>) => {
          const result: boolean | undefined = resp.success;
          const error: ResponseError | undefined = resp.error;

          if (result) {
            this.props.history.push(`/whs/do/return-drv-signature/${orderNumber}/${awbCode}/${awbNumber}/${awbVersion}`);
          }

          if (error) {
            this.props.receiveError(error);
          };
        })
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  handleAttachmentUpload = (event: any) => {
    if(event.target.files[0]) {
      const formData: FormData = new FormData();
      formData.append('attachment', event.target.files[0]);
  
      pickupOrderRemote.uploadGhaPoAwbWhExceptionsAttachments(this.props.match.params.orderNumber, this.props.match.params.awbCode, this.props.match.params.awbNumber, formData).then((resp) => {
        const attachments: string[] | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
        
        if (attachments) {
          let exceptions = Object.assign({}, this.state.exceptions);
          exceptions.attachments = attachments;
          this.setState({exceptions});
        }
  
        if (error) {
          this.props.receiveError(error);
        };
      });
    }
  }

  handleAttachmentDelete = (attachmentKey: string) => {
    
    pickupOrderRemote.deleteGhaPoAwbWhExceptionsAttachment(attachmentKey).then((resp) => {
      const attachments: string[] | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;
      
      if (attachments) {
        let exceptions = Object.assign({}, this.state.exceptions);
        exceptions.attachments = attachments;
        this.setState({exceptions});
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  render() {

    return (
      
      <>
        <WhsOrderAwbReport
          awbNumber={ this.state.selectedAwb }
          exceptions={ this.state.exceptions }
          handleChange={ this.handleChange }
          handleAttachmentDelete={ this.handleAttachmentDelete }
          handleAttachmentUpload={ this.handleAttachmentUpload }
          returnToDriverAwb={ this.returnToDriverAwb }
          saveExit={ this.saveExit }
          type={ this.props.type }
          showOnPodChange={ this.showOnPodChange }
          onlyRead={ this.state.onlyRead }
          show_on_pod={ this.state.orderAwb.show_on_pod }
          selectAll={ this.selectAllChange }
          selectValue={ this.state.selectAll }
          userRole='whs'
        />
      </>
    )
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};
  
export default connect(null, mapDispatchToProps)(WhsOrderAwbReportContainer);
